import { inject, provide, ref, Ref } from "vue";
import type { InjectionKey } from "vue";

export const GROUPING_TOGGLE_DISABLED_KEY: InjectionKey<Ref<boolean>> = Symbol("groupingToggleDisabled");

export const provideGroupingToggleDisabled = (disabled: Ref<boolean>) =>
    provide(GROUPING_TOGGLE_DISABLED_KEY, disabled);

export const useGroupingToggleDisabled = () => inject(GROUPING_TOGGLE_DISABLED_KEY, ref(false));
